<div class="as-suggestion-container">
  <div class="as-suggestions-header">
    <div class="as-sugestions-header-container">
      <div class="cont">
        <mat-label class="as-roboto-slab as-font-24 as-font-bold">
          {{ 'CART.beforeProceeding' | translate }}
        </mat-label>
      </div>
      <div class="cont">
        <mat-label> {{ 'CART.forgotProducts' | translate }} </mat-label>
        <a [routerLink]="['/compra-en-proceso']">
          <button mat-flat-button class="as-continue-button" color="accent">
            <mat-label class="as-font-14 as-font-semibold as-font-white">
              {{ 'GENERAL.continue' | translate }}
            </mat-label>
          </button>
        </a>
      </div>
    </div>
  </div>
  <div class="as-suggestion">
    <div
      class="as-product-promos"
      [class.as-mt-100]="screenWidth > 800"
      [class.as-mt-120]="screenWidth <= 800 && screenWidth > 425"
      [class.as-mt-190]="screenWidth <= 425"
    >
      @if (!isMobile) {
      <div><br /><br /></div>
      } @if (carouselRecommendations?.items?.length) {
      <div class="as-home-lists">
        <div class="as-row as-justify-sb as-align-end">
          <mat-label class="as-roboto-slab as-font-24 as-font-bold">
            {{ carouselRecommendations.name }}
          </mat-label>
          @if (carouselRecommendations.see_more) {
          <a
            [routerLink]="['/recomendaciones']"
            [queryParams]="{ checkout: 'true' }"
            class="as-font-green as-font-semibold as-pointer as-font-underline"
          >
            {{ 'PURCHASE.seeMore' | translate }}
          </a>
          }
        </div>
        <br />
        @if (isBrowser) {
        <carousel
          [loop]="false"
          [autoplay]="false"
          [height]="carouselProductsHeight"
          [arrows]="!isMobile && carouselRecommendations.items.length > 7"
          class="as-row"
          [margin]="10"
          [cellWidth]="carouselProductsWidth"
        >
          @for (product of carouselRecommendations.items; track product) {
          <app-product-card class="carousel-cell" [product]="product">
          </app-product-card>
          }
        </carousel>
        }
      </div>
      }
    </div>
    @if (promos.length) {
    <div
      class="as-product-promos"
      [class.as-mt-100]="screenWidth > 800 && !carouselRecommendations.items"
      [class.as-mt-120]="
        screenWidth <= 800 &&
        screenWidth > 425 &&
        !carouselRecommendations.items
      "
      [class.as-mt-190]="screenWidth <= 425 && !carouselRecommendations.items"
    >
      @for (promo of promos; track promo) {
      <div class="as-column as-align-center">
        <div class="as-promos-container">
          <div class="as-promo">
            <app-product-promo [promo]="promo"></app-product-promo>
          </div>
        </div>
        @if (promo.items.length) {
        <div class="as-home-lists">
          <div class="as-row as-justify-sb as-align-end">
            <mat-label class="as-roboto-slab as-font-24 as-font-bold">
              {{ changeName(promo.name) }}
            </mat-label>
            @if (promo.items.length > 15) {
            <a
              [routerLink]="promo.carrousel_url"
              [queryParams]="{ id: promo.name }"
              class="as-font-green as-font-semibold as-pointer"
              (click)="onSeeMoreNavigation()"
            >
              {{ 'PURCHASE.seeMore' | translate }}
            </a>
            }
          </div>
          <br />
          @if (isBrowser) {
          <carousel
            [height]="carouselProductsHeight"
            [autoplay]="false"
            [arrows]="!isMobile && promo?.items?.length! > 7"
            class="as-row"
            [margin]="10"
            [cellWidth]="carouselProductsWidth"
          >
            @for (product of promo?.items; track product) {
            <app-product-card class="carousel-cell" [product]="product">
            </app-product-card>
            }
          </carousel>
          }
        </div>
        }<br />
      </div>
      }
    </div>
    } @else {
    <div class="as-skeleton-container">
      <div class="as-skeleton-banner"></div>
      <div class="as-skeleton-card-container">
        @for (product of skeletonList; track product) {
        <div class="as-skeleton-card">
          <div class="as-image-skeleton"></div>
          <div class="as-description-line as-line-1"></div>
          <div class="as-description-line as-line-2"></div>
          <div class="as-description-line as-line-3"></div>
        </div>
        }
      </div>
    </div>
    }
    <div style="display: none" class="as-row as-justify-end">
      <a [routerLink]="['/compra-en-proceso']">
        <button
          mat-flat-button
          class="as-continue-button-bottom"
          color="accent"
        >
          <mat-label class="as-font-14 as-font-semibold as-font-white">
            {{ 'GENERAL.continue' | translate }}
          </mat-label>
        </button>
      </a>
    </div>
    <a [routerLink]="['/compra-en-proceso']" style="display: none">
      <button mat-flat-button class="as-continue-bottom" color="accent">
        <mat-label class="as-font-semibold">
          {{ 'GENERAL.continue' | translate }}
        </mat-label>
      </button>
    </a>
  </div>
</div>
